<bit-badge-list [items]="groupNames" [maxItems]="3" variant="secondary"></bit-badge-list>
